<script setup lang="ts">
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { ContextAccess } from '@shared/Root/Context.access';
    import { inject } from 'vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const contextAccess: ContextAccess = injectorAccess.injector.get(ContextAccess);

    const redirectToPaymentFailed = () => {
        window.location.href = '/Account/PaymentFailed';
    };
</script>

<template>
    <div v-if="contextAccess.state.currentAccount">
        <div class="alert alert-danger alert-fixed-i" v-if="contextAccess.state.currentAccount.ServiceSubscriptionStatus === 6">
            <p>
                <i class="fa fa-ban" aria-hidden="true"></i>
                <strong class="m-sm-r">{{ $Resources.AccountPaymentFailedHeading }}</strong>
                <span>{{ $Resources.AccountPaymentFailedBody }}</span>
            </p>
            <div class="form-group d-flex gap-sm flex-wrap">
                <button type="button" class="btn btn-xs" @click="redirectToPaymentFailed">{{ $Resources.AccountPaymentFailedButton }}</button>
            </div>
        </div>

        <div class="alert alert-danger alert-fixed-i" v-if="contextAccess.state.currentAccount.AccountCancelled">
            <p>
                <i class="fa fa-ban" aria-hidden="true"></i>
                <strong class="m-sm-r">{{ $Resources.AccountCancelledHeading }}</strong>
                <span>{{ $Resources.AccountCancelledBody }}</span>
            </p>
        </div>
    </div>
</template>

<style scoped></style>
